/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190902 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import { EmpJobMappingsDaoService } from '../emp-job-mapping-dao.service';
import { EmpJobMapping } from 'src/app/_model/emp-job-mapping';
import { KeyValuePersistenceService } from 'src/app/_services/persistence/key-value-persistence/key-value-persistence.service';


// CONSTANTS
const EMP_JOB_MAPPING_KEY = 'empJobMappings';
const EMP_JOB_MAPPING_UPDATE_TEAM_KEY = 'empJobMappingLastUpdateTeam';

@Injectable()
export class EmpJobMappingsStorageDaoService
  implements EmpJobMappingsDaoService {
  // Private Member

  constructor(
    private logger: LoggingService,
    private keyValueStorage: KeyValuePersistenceService
  ) {}

  public async getLastUpdatedTeam(): Promise<number> {
    const timestamp = await this.keyValueStorage.load(EMP_JOB_MAPPING_UPDATE_TEAM_KEY)
    return timestamp ?? 0
  }
  public async setLastUpdatedTeam(timestamp: number): Promise<void> {
    await this.keyValueStorage.store(EMP_JOB_MAPPING_UPDATE_TEAM_KEY, timestamp);
  }

  public async saveEmpJobMappings(
    empJobMappings: EmpJobMapping[]
  ): Promise<void> {
    return this.keyValueStorage.store(EMP_JOB_MAPPING_KEY, empJobMappings);
  }

  public async getEmpJobMappings(): Promise<EmpJobMapping[]> {
    return (await this.keyValueStorage.load(EMP_JOB_MAPPING_KEY)) ?? []
  }

  public async reset() {
    await this.keyValueStorage.delete(EMP_JOB_MAPPING_UPDATE_TEAM_KEY);
  }

  public async clear() {
    await this.keyValueStorage.delete(EMP_JOB_MAPPING_KEY);
    await this.keyValueStorage.delete(EMP_JOB_MAPPING_UPDATE_TEAM_KEY);
  }

  // Private Functions
}
